/** How many labels the trigger spells out before the remainder becomes a count. */
export const SUMMARY_LABEL_LIMIT = 2;

/**
 * What a filled trigger says after its category: the first two labels, then a count of the rest.
 *
 *   ['Admin']                      → "Admin"
 *   ['Admin', 'Editor']            → "Admin, Editor"
 *   ['Admin', 'Editor', 'Viewer']  → "Admin, Editor +1 more"
 *
 * Two labels rather than one because a person can only see which values are applied by opening the
 * panel otherwise, and the Figma set draws a tooltip-less trigger (Mobbin: Airtable names every value
 * on its chip). Not `MultiSelect`'s formatter, which draws a count ("2 selections") and has no room
 * for names, so the two are not shared even though they read alike.
 *
 * `more` is the caller's, for translation and plurals; this layer ships no English.
 */
export const formatFilterSummary = (pickedLabels: string[], more: (count: number) => string): string => {
  const shown = pickedLabels.slice(0, SUMMARY_LABEL_LIMIT).join(', ');
  const rest = pickedLabels.length - SUMMARY_LABEL_LIMIT;
  return rest > 0 ? `${shown} ${more(rest)}` : shown;
};
